/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./consumerList.vue?vue&type=template&id=88de6d60"
import script from "./consumerList.vue?vue&type=script&lang=js"
export * from "./consumerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports